// tab
jQuery(function($) {
  if ($('.js-fadeImage').length) {
    window.addEventListener('load', function() {
      var _mql = window.matchMedia('screen and (max-width: 767px)');
      var _mqlPc = window.matchMedia('screen and (min-width: 768px)');
      // 設定
      var fadeSlide;
      var $interval = 5000; // 切り替わりの間隔（ミリ秒）
      var $fade_speed = 1000; // フェード処理の早さ（ミリ秒）

      _mql.addListener(routingByBreakpoint);
      // ▼初回ロード時
      routingByBreakpoint(_mql);

      // ▼関数
      function routingByBreakpoint(_mql) {
        if (_mql.matches) {
          console.log('spサイズだお');
          startFadeSlide();
        } else {
          clearInterval(fadeSlide);
        }
      }
      function startFadeSlide() {
        fadeSlide = setInterval(function() {
          $('.js-fadeImage').each(function() {
            var $active = $(this).children('img.is-active');
            var $next = $active.next('img').length?$active.next('img'):$(this).children('img:first');
            $active.animate({opacity: 0}, 1000).removeClass('is-active');
            $next.animate({opacity: 1}, 1000).addClass('is-active');
          });
          console.log('fadeSlideしてる');
        }, $interval);
      }

    });// window.addEventListener('load', function() {
  }// if ($('.js-fadeImage').length) {
});
